/* eslint-disable react/prop-types */
import React, { useEffect, useState, useContext } from "react";
import TableInstance from "./table-instance";
import PropTypes from "prop-types";
import { useLocation, useSearchParams, useParams } from "react-router-dom";
import { GetSortBy } from "../../utils/sortby";
import { OrderDetailsData } from "../../contexts";
import { COLUMNS_FUCTIONALITIES } from "./Constants";
import { ALL_ORDER_TYPE, CHRONICITY_MAP, PRESORTED_ORDER_TYPE, STRIPS_ORDER_TYPE, TENANT_COMPANY_MAP } from "../../utils/constants";
import { getTenantId } from "../../utils/helpers";
import GetAllOrders from "../../hooks/fetch-hooks/fetch-all/get-all-orders";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Loader from "../Loader";
import GetAllReOrders from "../../hooks/fetch-hooks/fetch-all/get-all-reorders";
import moment from "moment";
import { DEFAULT_PAGE_SIZE, LEGACY_DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE } from "../../v2/constants/pagination";

// Guards the export loop against a runaway count: 200 pages x 500 = 100k orders.
const MAX_EXPORT_PAGES = 200;

const clampPageSize = (value, fallback) => {
    const parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1) return fallback;
    return Math.min(parsed, MAX_PAGE_SIZE);
};
import { consoleForPath } from "../../v2/constants/consoles";

const CHRONICITY_OPTIONS = [
    { value: 'NONE', label: 'None' },
    ...Object.keys(CHRONICITY_MAP).map((key) => ({ value: key, label: CHRONICITY_MAP[key] }))
];

async function Response(pageindex, pagelimit, search, order, orderBy, userId, OrderType, selectedStatus, isReorder, from, to, createdFrom, createdTill, daysLeft, chronicity, searchBy, partnerId) {
    const chronicityParam = chronicity?.length > 0 ? chronicity.join(',') : null;
    const nameSearch = searchBy === 'name' ? search : undefined;
    const mrnSearch = searchBy === 'mrn' ? search : undefined;
    const inventoryIdSearch = searchBy === 'inventoryId' ? search?.trim() : undefined;
    let response;
    switch (OrderType) {
        case 'UserOrder':
            response = await GetAllOrders({
                userId: userId,
                page: pageindex,
                size: pagelimit,
                orderBy: orderBy,
                status: selectedStatus.map((status) => status).join(','),
                chronicity: chronicityParam,
            }, '')
            break;
        case ALL_ORDER_TYPE:
            response = !isReorder ? await GetAllOrders({
                page: pageindex,
                size: pagelimit,
                // Omitted entirely when unset, so "All partners" sends no partnerId at all
                // rather than partnerId=undefined landing in the query string.
                ...(partnerId ? { partnerId } : {}),
                patientName: nameSearch,
                userName: nameSearch,
                partnerEntityId: mrnSearch,
                inventoryId: inventoryIdSearch,
                order: order,
                orderBy: orderBy,
                userId: userId,
                status: selectedStatus.map((status) => status).join(','),
                type: 'ALL',
                endDateAt: from || null,
                endDateTill: to || null,
                chronicity: chronicityParam,
                createdAt: createdFrom || null,
                createdTill: createdTill || null,
            }, '') : await GetAllReOrders({
                page: pageindex,
                size: pagelimit,
                // Omitted entirely when unset, so "All partners" sends no partnerId at all
                // rather than partnerId=undefined landing in the query string.
                ...(partnerId ? { partnerId } : {}),
                patientName: nameSearch,
                userName: nameSearch,
                partnerEntityId: mrnSearch,
                inventoryId: inventoryIdSearch,
                order: order,
                orderBy: orderBy,
                userId: userId,
                status: selectedStatus.map((status) => status).join(','),
                type: 'ALL',
                endDateAt: from || null,
                endDateTill: to || null,
                chronicity: chronicityParam,
                createdAt: createdFrom || null,
                createdTill: createdTill || null,
            }, daysLeft)
            break;
        case PRESORTED_ORDER_TYPE:
            response = !isReorder ? await GetAllOrders({
                page: pageindex,
                size: pagelimit,
                // Omitted entirely when unset, so "All partners" sends no partnerId at all
                // rather than partnerId=undefined landing in the query string.
                ...(partnerId ? { partnerId } : {}),
                patientName: nameSearch,
                userName: nameSearch,
                partnerEntityId: mrnSearch,
                inventoryId: inventoryIdSearch,
                order: order,
                orderBy: orderBy,
                userId: userId,
                status: selectedStatus.map((status) => status).join(','),
                type: 'PRESORTED',
                chronicity: chronicityParam,
                createdAt: createdFrom || null,
                createdTill: createdTill || null,
                endDateAt: from || null,
                endDateTill: to || null,
            }, '') : await GetAllReOrders({
                page: pageindex,
                size: pagelimit,
                // Omitted entirely when unset, so "All partners" sends no partnerId at all
                // rather than partnerId=undefined landing in the query string.
                ...(partnerId ? { partnerId } : {}),
                patientName: nameSearch,
                userName: nameSearch,
                partnerEntityId: mrnSearch,
                inventoryId: inventoryIdSearch,
                order: order,
                orderBy: orderBy,
                userId: userId,
                status: selectedStatus.map((status) => status).join(','),
                type: 'PRESORTED',
                endDateAt: from || null,
                endDateTill: to || null,
                chronicity: chronicityParam,
                createdAt: createdFrom || null,
                createdTill: createdTill || null,
            }, daysLeft)
            break;
        case STRIPS_ORDER_TYPE:
            response = !isReorder ? await GetAllOrders({
                page: pageindex,
                size: pagelimit,
                // Omitted entirely when unset, so "All partners" sends no partnerId at all
                // rather than partnerId=undefined landing in the query string.
                ...(partnerId ? { partnerId } : {}),
                patientName: nameSearch,
                userName: nameSearch,
                partnerEntityId: mrnSearch,
                inventoryId: inventoryIdSearch,
                order: order,
                orderBy: orderBy,
                userId: userId,
                status: selectedStatus.map((status) => status).join(','),
                type: 'STRIPS',
                chronicity: chronicityParam,
                createdAt: createdFrom || null,
                createdTill: createdTill || null,
                endDateAt: from || null,
                endDateTill: to || null,
            }, '') : await GetAllReOrders({
                page: pageindex,
                size: pagelimit,
                // Omitted entirely when unset, so "All partners" sends no partnerId at all
                // rather than partnerId=undefined landing in the query string.
                ...(partnerId ? { partnerId } : {}),
                patientName: nameSearch,
                userName: nameSearch,
                partnerEntityId: mrnSearch,
                inventoryId: inventoryIdSearch,
                order: order,
                orderBy: orderBy,
                userId: userId,
                status: selectedStatus.map((status) => status).join(','),
                type: 'STRIPS',
                endDateAt: from || null,
                endDateTill: to || null,
                chronicity: chronicityParam,
                createdAt: createdFrom || null,
                createdTill: createdTill || null,
            }, daysLeft)
            break;
        default:
            response = await GetAllReOrders({
                page: pageindex,
                size: pagelimit,
                // Omitted entirely when unset, so "All partners" sends no partnerId at all
                // rather than partnerId=undefined landing in the query string.
                ...(partnerId ? { partnerId } : {}),
                patientName: nameSearch,
                userName: nameSearch,
                partnerEntityId: mrnSearch,
                inventoryId: inventoryIdSearch,
                order: order,
                orderBy: orderBy,
                userId: userId,
                status: selectedStatus.map((status) => status).join(','),
                createdAt: from || null,
                createdTill: to || null,
                endDateAt: from || null,
                endDateTill: to || null,
                chronicity: chronicityParam,
            }, daysLeft)
            break;
    }
    return response
}

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

/**
 * The page length to default to, decided by which shell this table is mounted in.
 *
 * This one component backs six legacy routes (/all-orders, /partner-orders,
 * /future-orders, /user-details/:id, /digitize-orders) AND the Reorders tab in both v2
 * consoles. Legacy has always paged at 50 and should keep doing so; the v2 consoles page
 * at 20 like every other list in them. Rather than thread a prop through five call
 * sites -- and rely on each of them remembering -- the table asks where it is.
 *
 * consoleForPath is the same helper ConsoleSwitcher uses to decide which tab is active,
 * so this table and the switcher can never disagree about which console you are in. It
 * treats anything outside /v2/* as legacy, which is the safe default for a new mount.
 */
const useDefaultPageSize = () => {
    const { pathname } = useLocation();
    return consoleForPath(pathname) === "legacy" ? LEGACY_DEFAULT_PAGE_SIZE : DEFAULT_PAGE_SIZE;
};

const FiltersModal = ({ filterOpen, onOpen, filterData, setFilterData }) => {

    const defaultPageSize = useDefaultPageSize();
    const [tempFilterData, setTempFilterData] = React.useState({ ...filterData });

    const handleApplyFilters = () => {
        setFilterData({ ...tempFilterData, pageSize: clampPageSize(tempFilterData.pageSize, defaultPageSize) });
        onOpen(false);
    }

    const handleClearFilters = () => {
        // Resets to whatever this shell's default is, not a hardcoded number -- clearing
        // filters in the legacy dashboard must not silently re-page it at the v2 length.
        setTempFilterData({ from: '', to: '', createdFrom: '', createdTill: '', pageSize: defaultPageSize, chronicity: [] });
        setFilterData({ from: '', to: '', createdFrom: '', createdTill: '', pageSize: defaultPageSize, chronicity: [] });
        onOpen(false);
    }

    useEffect(() => {
        if (filterOpen) {
            setTempFilterData({ ...filterData });
        }
    }, [filterOpen]);

    return (
        <div className='fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-[500]' >
            {<div className="w-full flex flex-col justify-center">
                <div
                    style={{ backgroundColor: "white", width: "36vw", marginLeft: "32vw" }}
                    className="flex flex-col gap-4 justify-center p-4"
                >
                    <div className="flex justify-between items-center">
                        <span className='text-2xl font-bold'>Filters</span>
                        <button onClick={() => onOpen(false)}>
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </div>
                    <hr />
                    <div className="flex flex-col gap-2">
                        <label className="font-bold">Page Size</label>
                        <input
                            type="number"
                            min={1}
                            max={MAX_PAGE_SIZE}
                            className="px-6 w-full font-sans py-4 col-span-2 bg-white-50"
                            value={tempFilterData.pageSize}
                            onChange={(e) => setTempFilterData({ ...tempFilterData, pageSize: e.target.value })}
                        />
                        <p className="text-xs text-gray-500">Maximum {MAX_PAGE_SIZE} per page. Download (Excel) always exports every matching order.</p>
                        <label className="font-bold">Created At Date Range</label>
                        <div className="flex gap-4 items-center">
                            <div>
                                <label className="text-sm">From</label>
                                <input
                                    type="date"
                                    className="border rounded-md p-1 ml-2"
                                    value={tempFilterData.createdFrom}
                                    onChange={(e) => setTempFilterData({ ...tempFilterData, createdFrom: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="text-sm">To</label>
                                <input
                                    type="date"
                                    className="border rounded-md p-1 ml-2"
                                    value={tempFilterData.createdTill}
                                    disabled={!tempFilterData.createdFrom}
                                    onChange={(e) => setTempFilterData({ ...tempFilterData, createdTill: moment(tempFilterData.createdFrom).isAfter(e.target.value) ? tempFilterData.createdFrom : e.target.value })}
                                />
                            </div>
                        </div>
                        <label className="font-bold">End Date Range</label>
                        <div className="flex gap-4 items-center">
                            <div>
                                <label className="text-sm">From</label>
                                <input
                                    type="date"
                                    className="border rounded-md p-1 ml-2"
                                    value={tempFilterData.from}
                                    onChange={(e) => setTempFilterData({ ...tempFilterData, from: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="text-sm">To</label>
                                <input
                                    type="date"
                                    className="border rounded-md p-1 ml-2"
                                    value={tempFilterData.to}
                                    disabled={!tempFilterData.from}
                                    onChange={(e) => setTempFilterData({ ...tempFilterData, to: moment(tempFilterData.from).isAfter(e.target.value) ? tempFilterData.from : e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="font-bold">Chronicity</label>
                        <div className="flex flex-wrap gap-2">
                            {CHRONICITY_OPTIONS.map((option) => (
                                <button
                                    key={option.value}
                                    className={`text-sm px-3 py-1 rounded-full border ${tempFilterData.chronicity?.includes(option.value)
                                        ? 'bg-[#00A48B] text-white-50 border-[#00A48B]'
                                        : 'bg-white text-gray-700 border-gray-300'
                                        }`}
                                    onClick={() => {
                                        setTempFilterData((prev) => {
                                            const current = prev.chronicity || [];
                                            const updated = current.includes(option.value)
                                                ? current.filter((v) => v !== option.value)
                                                : [...current, option.value];
                                            return { ...prev, chronicity: updated };
                                        });
                                    }}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="flex justify-end gap-2 mt-4">
                        <button
                            className="bg-gray-200 px-4 py-1 rounded-md"
                            onClick={handleClearFilters}
                        >
                            Clear
                        </button>
                        <button
                            className="bg-[#00A48B] text-white-50 px-4 py-1 rounded-md"
                            onClick={handleApplyFilters}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>}
        </div>
    )
}

function OrdersTable({ changeRightBarOpen }) {
    const defaultPageSize = useDefaultPageSize();
    const { OrderType, setOrderType, isReorder, partnerId } = useContext(OrderDetailsData);
    const [daysLeft, setDaysLeft] = useState(30);
    const query = useQuery();
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams()
    // Main States
    const { id } = useParams()
    const [tableData, setTableData] = React.useState([]);
    // eslint-disable-next-line no-unused-vars
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [pageSort, setPageSort] = React.useState([])
    //  All States for query
    const [pageindex, setPageIndex] = React.useState(query.get('page') || 1);
    // eslint-disable-next-line
    const pageSizeStr = clampPageSize(query.get('size'), defaultPageSize);
    const fromStr = query.get('from') || '';
    const toStr = query.get('to') || '';
    const createdFromStr = query.get('createdFrom') || '';
    const createdTillStr = query.get('createdTill') || '';
    const chronicityStr = query.get('chronicity') || '';
    const chronicityArray = chronicityStr ? chronicityStr.split(',') : [];
    // eslint-disable-next-line
    const [value, setValue] = React.useState(query.get('search') || "");
    const [debouncedSearch, setDebouncedSearch] = React.useState(value);
    const [order, setOrder] = React.useState(isReorder ? 'ASC' : undefined)
    const [orderBy, setOrderBy] = React.useState(isReorder ? 'endDate' : undefined);
    const [selectedStatus, setSelectedStatus] = useState([]);
    // UseEffect Starts Here

    const isEazy = getTenantId() === TENANT_COMPANY_MAP.EAZY;
    const [searchBy, setSearchBy] = useState('name');
    const [filterOpen, setFilterOpen] = useState(false);
    const [filterData, setFilterData] = useState({
        from: fromStr,
        to: toStr,
        pageSize: pageSizeStr,
        createdFrom: createdFromStr,
        createdTill: createdTillStr,
        chronicity: chronicityArray,
    });


    useEffect(() => {
        if (pageSort.length > 0) {
            setOrder(pageSort[0].desc ? "DESC" : "ASC")
            setOrderBy(GetSortBy(pageSort[0].id))
        }
        else if (pageSort.length < 1) {
            setOrder(undefined)
            setOrderBy(undefined)
        }
    }, [pageSort])
    const withDaysLeft = (order) => ({
        ...order,
        daysLeft: Math.floor(
            (new Date(order.endDate) - new Date()) / (1000 * 60 * 60 * 24) + 2
        ),
    });

    const fetchOrdersPage = (pageNo, size) => {
        let leftDays = daysLeft === '' ? 0 : daysLeft
        return Response(pageNo, size, debouncedSearch, order, orderBy, id, OrderType, selectedStatus, isReorder, filterData.from, filterData.to, filterData.createdFrom, filterData.createdTill, leftDays, filterData.chronicity, searchBy, partnerId);
    };

    const getData = async () => {
        setIsLoading(true);
        try {
            const fetchedData = await fetchOrdersPage(pageindex, filterData.pageSize);
            const newTableData = (fetchedData?.data?.data?.rows ?? []).map(withDaysLeft);
            setTableData(newTableData);
            setTotal(fetchedData?.data?.data?.count || 0);
        } finally {
            setIsLoading(false);
        }
    };

    // Every order matching the current filters, for the Excel export. The table only holds
    // one page, and the API caps a page at MAX_PAGE_SIZE, so this walks the pages itself.
    // It throws on any failed page rather than returning a partial list -- a silently short
    // spreadsheet is worse than an error.
    const fetchAllOrders = async () => {
        const all = [];
        for (let pageNo = 1; pageNo <= MAX_EXPORT_PAGES; pageNo++) {
            const response = await fetchOrdersPage(pageNo, MAX_PAGE_SIZE);
            if (!response?.data?.success) {
                throw new Error(typeof response?.data?.error === 'string' ? response.data.error : 'Could not load orders for export');
            }
            const rows = response.data.data?.rows ?? [];
            all.push(...rows.map(withDaysLeft));
            if (rows.length < MAX_PAGE_SIZE || all.length >= (response.data.data?.count ?? 0)) break;
        }
        return all;
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(value);
            setPageIndex(1);
        }, 300);
        return () => clearTimeout(timer);
    }, [value]);

    // A new filter set changes the result count, so the old page may no longer exist.
    // Skips the first run so a page number restored from the URL survives a reload.
    const filtersMounted = React.useRef(false);
    useEffect(() => {
        if (!filtersMounted.current) {
            filtersMounted.current = true;
            return;
        }
        setPageIndex(1);
    }, [filterData, selectedStatus, OrderType, searchBy]);

    useEffect(() => {
        getData();
    }, [pageindex, debouncedSearch, order, orderBy, daysLeft, selectedStatus, OrderType, filterData, searchBy, partnerId]);


    useEffect(() => {
        setSearchParams({
            page: pageindex,
            size: filterData.pageSize,
            search: value,
            from: filterData.from,
            to: filterData.to,
            createdFrom: filterData.createdFrom,
            createdTill: filterData.createdTill,
            chronicity: filterData.chronicity?.join(','),
        })
    }, [pageindex, value, filterData]);


    const maxValues = Math.ceil(total / filterData.pageSize);

    const handleDeleteRow = (id) => {
        const newData = tableData.filter((item) => item.id !== id)
        setTableData(newData);
    }
    // Every value here must exist in Postgres' enum_userOrders_status. A value that only
    // exists as a JS constant (ORDER_DRAFT and ORDER_DRAFT_MANUAL_INTERVENTION were the
    // offenders) makes Postgres reject the ENTIRE query, so one bad entry breaks the whole
    // filter chip rather than just being ignored.
    const options = [
        { value: 'ORDER_PENDING,ORDER_INACTIVE,ORDER_UPLOADRX,CALL_PENDING,CALL_PICKED,RX_SENT,RX_SEND', label: 'Order Pending' },
        { value: 'ORDER_ACTIVE', label: 'Order Confirmed' },
        { value: 'ORDER_CANCELLED', label: 'Order Cancelled' },
        { value: 'CONSENT_GRANTED,PAYMENT_PENDING', label: 'Payment Pending' },
        { value: 'PAYMENT_SUCCESS', label: 'Payment Success' },
        { value: 'OCS_PENDING,OCS_PROCESSING', label: 'OCS Pending' },
        { value: 'USER_DRX_PENDING', label: 'DRX To Be Cofirmed' },
        { value: 'USER_DRX_ACCEPTED,CONSENT_PENDING', label: 'Consent Pending' },
        { value: 'SHIPPED_MEDICINES_PACKED,MDM_QC,SHIPPED_READY_TO_SHIP', label: 'Ready to Ship' },
        { value: 'SHIPPED_IN_TRANSIT', label: 'In Transit' },
        { value: 'DELIVERED', label: 'Delivered' },
        { value: 'SHIPPED_ERROR,USER_DRX_REJECTED', label: 'Needs Attention' },
    ]

    return (
        <>
            <div className="flex gap-4 items-center relative">
                <input
                    value={value}
                    className="px-6  font-sans w-[80%] bg-slate-100 py-4"
                    onChange={(e) => {
                        setValue(e.target.value);
                    }}
                    placeholder={searchBy === 'mrn' ? "Search by MRN..." : searchBy === 'inventoryId' ? "Search by Inventory ID..." : `${total} records...`}
                    style={{
                        fontSize: "1.1rem",
                        border: "0",
                    }}
                />
                <select
                    value={searchBy}
                    onChange={(e) => {
                        setValue("");
                        setDebouncedSearch("");
                        setSearchBy(e.target.value);
                    }}
                    className="border border-gray-300 rounded-lg px-3 py-2 text-sm"
                >
                    <option value="name">Search by Name</option>
                    <option value="inventoryId">Search by Inventory ID</option>
                    {isEazy && <option value="mrn">Search by MRN</option>}
                </select>
                {COLUMNS_FUCTIONALITIES[isReorder ? "ReOrder" : OrderType].includes("DaysLeft") && < div
                    className="flex justify-end items-center"
                >
                    <input
                        type="number"
                        onChange={(e) => { setDaysLeft(e.target.value) }}
                        className="focus:outline-none border-2 border-gray-300 rounded-2xl font-sans"
                        value={daysLeft}
                        style={{ zIndex: "0" }}
                    />
                </div>}

            </div >
            <div className="flex justify-start items-center my-[1rem] gap-2" >
                <div>
                    <button onClick={() => setOrderType(ALL_ORDER_TYPE)} className={`${OrderType === ALL_ORDER_TYPE ? "bg-elm-500 text-white-50" : "bg-transparent text-elm-500"} border-[1px] border-elm-500 px-4 hover:bg-elm-500 hover:text-white-50 font-semibold py-2 rounded-[9px]`}>
                        All Orders
                    </button>
                </div>
                <div>
                    <button onClick={() => setOrderType(PRESORTED_ORDER_TYPE)} className={`${OrderType === PRESORTED_ORDER_TYPE ? "bg-elm-500 text-white-50" : "bg-transparent text-elm-500"} border-[1px] border-elm-500 px-4 hover:bg-elm-500 hover:text-white-50 font-semibold py-2 rounded-[9px]`}>
                        Presorted
                    </button>
                </div>
                <div>
                    <button onClick={() => setOrderType(STRIPS_ORDER_TYPE)} className={`${OrderType === STRIPS_ORDER_TYPE ? "bg-elm-500 text-white-50" : "bg-transparent text-elm-500"} border-[1px] border-elm-500 px-4 hover:bg-elm-500 hover:text-white-50 font-semibold py-2 rounded-[9px]`}>
                        Strips
                    </button>
                </div>
            </div>
            <button className="bg-elm-500 text-white-50 px-4 py-1 rounded-md mr-3" onClick={() => setFilterOpen(true)}>Filters</button>
            {(filterData.from || filterData.to || filterData.createdFrom || filterData.createdTill || filterData.chronicity?.length > 0) && <button className="bg-red-500 text-white-50 px-4 py-1 rounded-md" onClick={() => setFilterData({ from: '', to: '', createdFrom: '', createdTill: '', pageSize: defaultPageSize, chronicity: [] })}>Clear Filters</button>}
            {
                filterOpen && <FiltersModal filterOpen={filterOpen} onOpen={setFilterOpen} filterData={filterData} setFilterData={setFilterData} />
            }
            {!isReorder && <div className="flex gap-4 items-center my-2 justify-start relative flex-wrap">
                {
                    options.map((option) => {
                        return <button key={option.value} className={`text-[10px] px-2 py-1 rounded-[10px] text-[#333] flex items-center gap-2 ${selectedStatus.includes(option.value) ? 'bg-elm-500 text-white-50' : 'bg-gray-200 text-[#333]'}`} onClick={() => setSelectedStatus((prev) => {
                            if (prev.includes(option.value)) {
                                return prev.filter((status) => status !== option.value)
                            }
                            return [...prev, option.value]
                        })}>{option.label}</button>
                    })
                }
            </div >}
            {isLoading ? (
                <Loader text="Loading orders..." />
            ) : (
                <TableInstance
                    tableData={tableData}
                    changeRightBarOpen={changeRightBarOpen}
                    pageCount={total}
                    setPageSort={setPageSort}
                    pageSort={pageSort}
                    handleDeleteRow={handleDeleteRow}
                    refetchOrders={getData}
                    fetchAllOrders={fetchAllOrders}
                />
            )}
            {/* Btns For Pagination  */}
            <div className="btn_div">
                <button onClick={() => setPageIndex((count) => Number(count) - 1)} disabled={pageindex <= 1} className="previous">
                    Previous
                </button>
                <span className="pageindex">
                    {`Page ${pageindex} of ${maxValues}`}
                </span>
                <button
                    onClick={() => setPageIndex((count) => Number(count) + 1)}
                    disabled={pageindex >= maxValues}
                    className="next"
                >
                    Next
                </button>
            </div>

        </>
    );
}

export default OrdersTable;

OrdersTable.propTypes = {
    changeRightBarOpen: PropTypes.func.isRequired,
    daysLeft: PropTypes.number,
};